
export enum PageRoutes {
    HOME = '/',
    LOGIN = '/login',
    SIGNUP = '/signup',
    EMAIL_SIGNUP = '/signup/email',
    EMAIL_SIGNUP_VERIFY = '/signup/email/verify',
    EMAIL_LOGIN = '/login/email',
    FORGOT_PASSWORD = '/login/forgot-password',
    ONBOARDING_BEST_DESCRIBES = '/signup/onboading/description',
    ONBOARDING_YOUR_DETAILS = '/signup/onboading/your-details',
    ONBOARDING_CATEGORIES = '/signup/onboading/categories',
    ONBOARDING_SEARCH_TERMS = '/signup/onboading/search-terms',
    PROFILE = '/profile',
    NOTIFICATION_SETTINGS = '/notification-settings',
    SEARCH = '/search',
    NOTIFICATIONS = '/notifications',
    BOOKINGS = '/bookings',
    AVAILABILITY = '/availability',
    SEARCH_RESULTS = '/search-results',
    MY_PROFILE = '/my-profile',
    FOLLOWING = '/following',
    VIDEO_CALL = '/video-call',
}